import { put, call, all, takeEvery, select } from 'redux-saga/effects';
import { toggleFeedbackPage, openNotificationsDropdown } from './actions';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { exitDuperbrowse, openDuperbrowse } from '../../Duperbrowse/redux/actionCreators';
import { FEEDBACK_PAGE_DUPERBROWSE_ITEMID, FEEDBACK_PAGE_DUPERBROWSE_STREAMID } from '../../Duperbrowse/redux/constants';
import { getIsFeedbackPageOpen } from './selectors';
import { logBiEvent } from '../../biLogger/redux/saga';
function* handleOpenNotificationDropdown() {
    // not using logPageView here because this is a fake pageview event and we
    // should avoid the side effects running
    yield call(logBiEvent, PureBiData({
        evid: 99,
        view: 'notifications',
        component: 'header'
    }));
}
function* handleToggleFeedbackPage() {
    const isOpen = yield select(getIsFeedbackPageOpen);
    if (isOpen) {
        yield put(exitDuperbrowse());
    } else {
        yield put(openDuperbrowse(FEEDBACK_PAGE_DUPERBROWSE_ITEMID, {
            streamId: FEEDBACK_PAGE_DUPERBROWSE_STREAMID,
            items: [
                FEEDBACK_PAGE_DUPERBROWSE_ITEMID
            ]
        }));
    }
}
export default function* saga() {
    yield all([
        takeEvery(openNotificationsDropdown, handleOpenNotificationDropdown),
        takeEvery(toggleFeedbackPage, handleToggleFeedbackPage)
    ]);
}

//# sourceMappingURL=saga.js.map